import { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { EDD_TABS } from "constants/eddConfig";
import EddCsvUploadTab from "./EddCsvUploadTab";
import VendorWorkingHours from "./VendorWorkingHours";
import VendorOffDays from "./VendorOffDays";
import { EddUploadContext } from "./EddUploadContext";

const EDD_TAB_COMPONENTS = {
  PROCUREMENT_SLA: <EddCsvUploadTab tabKey="PROCUREMENT_SLA" />,
  INVENTORY_LEAD_TIME: <EddCsvUploadTab tabKey="INVENTORY_LEAD_TIME" />,
  SERVICE_CENTRE_SLA: <EddCsvUploadTab tabKey="SERVICE_CENTRE_SLA" />,
  ORDER_PROCESSING_SLA: <EddCsvUploadTab tabKey="ORDER_PROCESSING_SLA" />,
  VENDOR_WORKING_HOURS: <VendorWorkingHours />,
  VENDOR_OFF_DAYS: <VendorOffDays />,
};

const EddUpload = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const [visitedTabs, setVisitedTabs] = useState([0]);
  const [isGlobalUploading, setIsGlobalUploading] = useState(false);

  const handleTabChange = (_, v) => {
    setActiveTab(v);
    if (!visitedTabs.includes(v)) {
      setVisitedTabs((prev) => [...prev, v]);
    }
  };

  return (
    <EddUploadContext.Provider
      value={{ isGlobalUploading, setIsGlobalUploading }}
    >
      <Box py={6}>
      <Box mb={4}>
        <Typography variant="h5" fontWeight="bold">
          EDD Master
        </Typography>
        <Typography fontSize={14} color="text.secondary">
          Upload CSV files for SLA tables and vendor calendars. Validation runs
          asynchronously; results appear in the Jobs table below each tab.
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 5 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            ">.MuiTabs-scroller": {
              ">.MuiTabs-indicator": {
                backgroundColor: theme.palette.common.black,
              },
              ">.MuiTabs-flexContainer>.Mui-selected": {
                fontWeight: 600,
                color: theme.palette.common.black,
              },
            },
          }}
        >
          {EDD_TABS.map((tab) => (
            <Tab key={tab.key || tab.label} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      {EDD_TABS.map((tab, index) => {
        if (!visitedTabs.includes(index)) return null;
        return (
          <Box
            key={tab.key || tab.label}
            sx={{ display: activeTab === index ? "block" : "none" }}
          >
            {EDD_TAB_COMPONENTS[tab.key]}
          </Box>
        );
      })}
      </Box>
    </EddUploadContext.Provider>
  );
};

export default EddUpload;
